// extracted by mini-css-extract-plugin
module.exports = {"icon":"advpopup_icon__B_gLZ","card":"advpopup_card__aJdDn","crossIcon":"advpopup_crossIcon__CFhO9"};